import queryString from 'query-string'

const { parseUrl: qsParseUrl, stringify: qsStringify } = queryString

const qsFields = {
  APP_ID: 'id',
  MOBILE: 'mobile',
  SKIN_ID: 'skin-id',
  RESUMABLE_SHARE: 'resumable-share'
}

export const getSharingSessionUrl = (clientConfiguration = {}, shareUrl) => {
  const {
    share: { url: endpointUrl } = { url: '' },
    scenarioId,
    clientSdkId = ''
  } = clientConfiguration

  const shareType = {}

  if (shareUrl) {
    shareType.shareUrl = shareUrl
  } else {
    shareType.scenarioId = scenarioId
  }

  return `${endpointUrl}${clientSdkId}?${qsStringify(shareType)}`
}

export const getSharingSessionWebsocketUrl = (sharingSessionDescriptor) => {
  const webSocketAddress = sharingSessionDescriptor.getWebsocketAddress()
  const sessionDefinition = sharingSessionDescriptor.getSessionDefinition()

  return `${webSocketAddress}/connect-sessions/${sessionDefinition}`
}

export const getSharingSessionQrCodeUrl = (sharingSessionDescriptor, configuration) => {
  const qrCodeUrl = sharingSessionDescriptor.getQrCodeUrl()
  try {
    const { skinId } = configuration
    const additionalQueries = {
      ...(skinId ? { [qsFields.SKIN_ID]: skinId } : {})
    }
    const stringifiedQueries = qsStringify({ ...additionalQueries })

    return `${qrCodeUrl}${stringifiedQueries ? `?${stringifiedQueries}` : ''}`
  } catch (e) {
    return qrCodeUrl
  }
}

export const getSharingSessionQrCodeAppLinkUrl = (sharingSessionDescriptor, configuration, context) => {
  const qrCodeUrl = sharingSessionDescriptor.getQrCodeUrl()
  const applicationId = sharingSessionDescriptor.getApplicationId()
  try {
    const { skinId, useResumeMobileFlow } = configuration
    const { currentUrl: contextUrl } = context
    const { query: contextQuery } = qsParseUrl(contextUrl)

    const additionalQueries = {
      [qsFields.APP_ID]: applicationId,
      [qsFields.MOBILE]: true,
      [qsFields.RESUMABLE_SHARE]: useResumeMobileFlow === true,
      ...(skinId ? { [qsFields.SKIN_ID]: skinId } : {})
    }

    const stringifiedQueries = qsStringify({
      ...contextQuery,
      ...additionalQueries
    })

    return `${qrCodeUrl}${stringifiedQueries ? `?${stringifiedQueries}` : ''}`
  } catch (error) {
    return ''
  }
}

export const getSharingSessionRedirectUrl = (sharingSessionDescriptor, context, additionalQueries) => {
  const callbackUrl = sharingSessionDescriptor.getCallbackUrl()

  try {
    const { currentUrl: contextUrl } = context
    const { query: contextQuery } = qsParseUrl(contextUrl)
    const { url: strippedCallbackUrl, query: callbackQuery } = qsParseUrl(callbackUrl)

    const stringifiedQueries = qsStringify({
      ...contextQuery,
      ...callbackQuery,
      ...additionalQueries
    })

    return `${strippedCallbackUrl}${stringifiedQueries ? `?${stringifiedQueries}` : ''}`
  } catch (error) {
    return ''
  }
}
